import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { activateAccount } from "../services/api";
import { useTranslation } from "react-i18next";

function Activate() {
  const { t } = useTranslation();
  const [code, setCode] = useState("");
  const [msg, setMsg] = useState("");
  const [redirecting, setRedirecting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || "";

  const handleActivate = async () => {
    if (!/^\d{6}$/.test(code)) {
      setMsg(t("activate.invalid_code"));
      return;
    }

    try {
      await activateAccount(code);
      setMsg(t("activate.success"));
      setRedirecting(true);
      setTimeout(() => navigate("/edit-profile"), 1500);
    } catch (error) {
      setMsg(t("activate.error"));
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleActivate();
  };

  return (
    <div className="bg-gray-100 min-h-screen px-4 pt-[80px] flex justify-center">
      <div
        className="bg-white shadow-xl rounded-2xl p-8 max-w-md w-full text-center space-y-6"
        role="main"
        aria-labelledby="activation-title"
      >
        <h2 id="activation-title" className="text-2xl font-bold text-gray-800">
          {email
            ? t("activate.title_with_email", { email })
            : t("activate.title")}
        </h2>

        <div className="text-left">
          <label htmlFor="activation-code" className="sr-only">
            {t("activate.label")}
          </label>
          <input
            id="activation-code"
            type="text"
            inputMode="numeric"
            pattern="\d*"
            placeholder={t("activate.placeholder")}
            aria-required="true"
            aria-label={t("activate.label")}
            aria-describedby="activation-help"
            maxLength="6"
            autoFocus
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
            onKeyDown={handleKeyDown}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-center text-lg"
          />
          <p id="activation-help" className="sr-only">
            {t("activate.help_text")}
          </p>
        </div>

        <button
          onClick={handleActivate}
          aria-label={t("activate.button")}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded-lg transition"
        >
          {t("activate.button")}
        </button>

        {msg && (
          <p
            role="alert"
            aria-live="assertive"
            className={`text-sm ${
              msg.includes("Error") ? "text-red-600" : "text-green-600"
            }`}
          >
            {msg}
          </p>
        )}
      </div>

      {redirecting && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          role="alertdialog"
          aria-live="assertive"
          aria-label={t("activate.redirecting")}
        >
          <div className="bg-white rounded-xl p-6 text-center shadow-lg space-y-4">
            <div
              className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto"
              aria-hidden="true"
            />
            <p className="text-blue-700 font-medium">{msg}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Activate;
